import React from "react";
import { Dialog } from "primereact/dialog";
import { QRCodeCanvas } from "qrcode.react";
import localeText from "../../../../../locale";

const ReferralQrDialog = ({ visible, onHide, url, titleKey }) => {
  const title = titleKey
    ? `${localeText("qrcodereferralLinks") || "QR Code"} (${localeText(titleKey) || titleKey})`
    : (localeText("qrcodereferralLinks") || "QR Code");

  return (
    <Dialog
      header={title}
      visible={visible}
      onHide={onHide}
      className="w-30rem m-2"
      draggable={false}
    >
      {url ? (
        <div className="flex flex-column justify-content-center align-items-center gap-2">
          <QRCodeCanvas value={url} size={200} />
        </div>
      ) : null}
    </Dialog>
  );
};

export default ReferralQrDialog;
